(function($) {
    'use strict';
    
    // Initialize HystModal
    const myModal = new HystModal({
        linkAttributeName: 'data-hystmodal',
        // Additional options if needed
        // backscroll: true,
        // beforeOpen: function(modal){},
        // afterClose: function(modal){},
    });
    
    // Focus on search input when modal opens
    document.addEventListener('afterModalOpen', function(e) {
        if (e.detail.modal.openedWindow.id === 'searchModal') {
            setTimeout(function() {
                document.getElementById('modal-search-field').focus();
            }, 100);
        }
    });
    
    // Optional: Add keyboard navigation for the modal
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            myModal.close();
        }
    });
    
})(jQuery);
